export default {
  data: () => ({
    saldo_devedor_proposta: null,
    grande_negocio: false,
    valor_grande_negocio: null
  }),
  methods: {
    calculaValorTotalSDNovaProposta (valor_bem, taxa_adm, qtd_cotas) {
      this.saldo_devedor_proposta = valor_bem * (1 + (taxa_adm / 100)) * qtd_cotas
    },

    calculaGrandeNegocio (saldo_devedor_cliente, vl_grande_negocio) {
      this.valor_grande_negocio = saldo_devedor_cliente + this.saldo_devedor_proposta

      this.grande_negocio = vl_grande_negocio !== 0 && this.valor_grande_negocio > vl_grande_negocio

      return this.grande_negocio
    }
  }
}
